const PageLoading = () => {
  return (
    <div className="wrap_loading">
      <span className="loader type_medium"></span>
      <span className="txt_loading">데이터 로딩중입니다.</span>
    </div>
  );
};

export default PageLoading;
